import React from 'react';
import { Moon, Sun, Clock } from 'lucide-react';
import ContentAccordion from '../components/common/ContentAccordion';
import { retreatContent } from '../data/retreatContent';

const ExamenPage = () => {
  return (
    <div className="px-4 py-6 max-w-lg mx-auto space-y-6">
      {/* Header */}
      <div className="text-center mb-6">
        <div className="w-16 h-16 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center mx-auto mb-4">
          <Moon className="w-8 h-8 text-white" />
        </div>
        <h1 className="font-heading text-2xl text-[var(--primary)] font-bold mb-1">
          {retreatContent.examen.title}
        </h1>
        <p className="text-gray-500 text-sm italic">{retreatContent.examen.subtitle}</p>
      </div>

      {/* Intro */}
      <div className="bg-gradient-to-br from-indigo-50 to-purple-50 rounded-xl p-4 border border-indigo-100">
        <p className="text-gray-700 leading-relaxed text-sm">
          {retreatContent.examen.intro}
        </p>
      </div>

      {/* When to Pray */}
      <div className="grid grid-cols-2 gap-3">
        <div className="bg-amber-50 rounded-xl p-4 border border-amber-100 text-center">
          <Sun className="w-6 h-6 text-amber-500 mx-auto mb-2" />
          <h4 className="font-semibold text-gray-800 text-sm">Midday Examen</h4>
          <p className="text-xs text-gray-500 mt-1">Pause and reflect at noon</p>
        </div>
        <div className="bg-indigo-50 rounded-xl p-4 border border-indigo-100 text-center">
          <Moon className="w-6 h-6 text-indigo-500 mx-auto mb-2" />
          <h4 className="font-semibold text-gray-800 text-sm">Evening Examen</h4>
          <p className="text-xs text-gray-500 mt-1">Review your day before bed</p>
        </div>
      </div>

      {/* The 5 Steps */}
      <div>
        <h3 className="font-heading font-semibold text-[var(--primary)] mb-4">The Five Steps</h3>
        <div className="space-y-3">
          {retreatContent.examen.steps.map((step) => (
            <div key={step.number} className="bg-white rounded-xl p-4 border border-gray-100">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-full bg-[var(--primary)] flex items-center justify-center flex-shrink-0">
                  <span className="font-bold text-white text-sm">{step.number}</span>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-800 mb-1">{step.title}</h4>
                  <p className="text-sm text-gray-600 leading-relaxed">{step.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Closing Note */}
      <div className="bg-[var(--primary)] rounded-xl p-4 text-white text-center">
        <Clock className="w-6 h-6 mx-auto mb-2 opacity-80" />
        <p className="font-accent text-lg italic">
          {retreatContent.examen.note}
        </p>
      </div>

      {/* Tips */}
      <ContentAccordion title="Tips for a Fruitful Examen" summary="Practical guidance for this prayer">
        <ul className="space-y-2 text-sm text-gray-600">
          <li className="flex items-start gap-2">
            <span className="text-[var(--primary)]">•</span>
            Find a quiet place where you won't be disturbed for 10-15 minutes.
          </li>
          <li className="flex items-start gap-2">
            <span className="text-[var(--primary)]">•</span>
            Begin and end with a brief prayer asking the Holy Spirit to guide you.
          </li>
          <li className="flex items-start gap-2">
            <span className="text-[var(--primary)]">•</span>
            Be honest with yourself and with God about your feelings and actions.
          </li>
          <li className="flex items-start gap-2">
            <span className="text-[var(--primary)]">•</span>
            Don't rush. Let memories surface naturally.
          </li>
          <li className="flex items-start gap-2">
            <span className="text-[var(--primary)]">•</span>
            Focus more on gratitude than on failures.
          </li>
          <li className="flex items-start gap-2">
            <span className="text-[var(--primary)]">•</span>
            Consider keeping a brief journal of insights that emerge.
          </li>
        </ul>
      </ContentAccordion>
    </div>
  );
};

export default ExamenPage;
